import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Calendar navigation toolbar — prev/next month, reset to today, close.
 * @param {object} props
 * @param {number} props.offset - current month offset from today
 * @param {function} props.onPrev - shift one month back
 * @param {function} props.onNext - shift one month forward
 * @param {function} props.onToday - reset offset to 0
 * @param {function} props.onClose - close the popup
 */
export default function CalendarToolbar({ offset, onPrev, onNext, onToday, onClose }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '10px' }}>
            {/* CHANGED — #294766 is border color, onleesbaar als icoon */}
            <IconButton size="small" onClick={onPrev} sx={{ color: '#b0c8e0', '&:hover': { color: '#a3d1ff' } }}>
                <ChevronLeftIcon fontSize="small" />
            </IconButton>

            <Typography
                onClick={onToday}
                sx={{
                    // CHANGED — #294766 onleesbaar, gebruik muted als offset=0
                    color: offset === 0 ? '#a3d1ff' : '#66b2ff',
                    fontSize: 11,
                    fontFamily: "'DM Sans', sans-serif",
                    cursor: offset === 0 ? 'default' : 'pointer',
                    '&:hover': { color: '#a3d1ff' },
                }}
            >
                vandaag
            </Typography>

            <IconButton size="small" onClick={onNext} sx={{ color: '#b0c8e0', '&:hover': { color: '#a3d1ff' } }}>
                <ChevronRightIcon fontSize="small" />
            </IconButton>

            <IconButton size="small" onClick={onClose} sx={{ color: '#b0c8e0', '&:hover': { color: '#ff6b6b' }, ml: 1 }}>
                <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
        </Box>
    );
}
